// extracted by mini-css-extract-plugin
export default {"btn":"Categories_btn__P7hSx"};